import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "u-copy-s gev19-infotext--grey"
}
const _hoisted_2 = {
  key: 1,
  class: "u-copy-s gev19-infotext--grey"
}
const _hoisted_3 = { class: "o-grid u-pad-x-1" }
const _hoisted_4 = { class: "o-media-object" }
const _hoisted_5 = { class: "o-media-object__media" }
const _hoisted_6 = { class: "o-media-object" }
const _hoisted_7 = { class: "o-media-object__media" }
const _hoisted_8 = { class: "o-grid u-pad-x-1" }
const _hoisted_9 = { class: "o-media-object" }
const _hoisted_10 = { class: "o-media-object__media" }
const _hoisted_11 = { class: "o-media-object" }
const _hoisted_12 = { class: "o-media-object__media" }
const _hoisted_13 = { class: "u-copy-s gev19-infotext--grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_gebaeude_typ_radio = _resolveComponent("gebaeude-typ-radio")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      active: 0,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, { titel: "Wohnobjekt" }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("Wohnfläche in m²")
            ])),
            _: 1,
            __: [21]
          }),
          _createVNode(_component_zelle, { breite: 3 }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.wohnflaeche) = $event)),
                id: "wohnflaeche",
                name: "wohnflaeche",
                type: "number",
                onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                class: "c-form-control__input",
                min: "16",
                max: "3000",
                required: "",
                "aria-required": "true",
                "aria-label": "Wohnfläche in Quadratmetern",
                placeholder: "m²",
                autofocus: "",
                "data-fehlermeldung": "Bitte geben Sie eine Wohnfläche in m² (mind. 16 m²) ohne Punkt und Komma ein.",
                "data-cy": "wohnflaeche",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.versicherungsSummeBerechnen()))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.gebaeudedaten.wohnflaeche,
                  void 0,
                  {
                    lazy: true,
                    trim: true,
                    number: true
                  }
                ]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.wohnflaeche
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_adresse, {
        fehler: _ctx.fehler,
        placeholder: true,
        plz: _ctx.piniaStore.state.risikoAnschrift.plz,
        "onUpdate:plz": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
        ort: _ctx.piniaStore.state.risikoAnschrift.ort,
        "onUpdate:ort": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
        strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
        "onUpdate:strasse": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
        hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
        "onUpdate:hausnummer": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
        feldNamen: {
        plz: 'risikoPlz',
        ort: 'risikoOrt',
        strasse: 'risikoStrasse',
        hausnummer: 'risikoHausnummer',
      },
        "sichtbare-felder": ['plz'],
        "clear-ort-on-plz-focus": true,
        ref: "risikoAdresseRef"
      }, {
        plzOrtLabel: _withCtx(() => [
          _cache[22] || (_cache[22] = _createTextVNode(" Postleitzahl des Wohnorts ")),
          (!_ctx.piniaStore.state.isMakler)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "gev19__contexthelp-open",
                title: "Hilfe anzeigen",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wechsleSichtbarkeit('beratungsAngebotDirekt')))
              }))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "gev19__contexthelp-open",
                title: "Hilfe anzeigen",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wechsleSichtbarkeit('beratungsAngebotMakler')))
              }))
        ]),
        _: 1
      }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer"]),
      (_ctx.sollGebaeudetypAbfragen)
        ? (_openBlock(), _createBlock(_component_gebaeude_typ_radio, {
            key: 0,
            fehler: _ctx.fehler,
            gebaeudetypen: _ctx.gebaeudetypen,
            required: _ctx.sollGebaeudetypAbfragen
          }, null, 8, ["fehler", "gebaeudetypen", "required"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 6,
            offset: 4
          }, {
            default: _withCtx(() => [
              (_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Die Hausratversicherung gilt für Häuser und Wohnungen, die ständig bewohnt sind und bei denen es sich um Massiv- oder Fertighäuser mit hartem Dach handelt. Bei Hausrat in Zweitwohnungen, anderen nicht ständig bewohnten Wohnungen oder Häusern sowie Wochenendhäusern sprechen Sie uns gerne an. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, " Unsere Hausratversicherung gilt für Häuser und Wohnungen, die ständig bewohnt sind und bei denen es sich um Massiv- oder Fertighäuser mit hartem Dach handelt. ")),
              _createVNode(_component_info_box, { id: "beratungsAngebotMakler" }, {
                default: _withCtx(() => [
                  _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "Sie benötigen ein individuelles Angebot?")
                  ], -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "u-copy-s" }, " Unser Maklervertriebscenter erstellt Ihnen gern ein individuelles Angebot. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr. ", -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_icon_sprite, {
                          "css-klassen": "u-color-primary",
                          "icon-name": "icon-phone"
                        })
                      ]),
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "o-media-object__content" }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            class: "inherited",
                            href: "tel:+49-40-3766-3222"
                          }, "Tel.: 040 3766 3222")
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_icon_sprite, {
                          "css-klassen": "u-color-primary",
                          "icon-name": "icon-paper-airplane"
                        })
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "o-media-object__content" }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            class: "inherited",
                            href: "mailto:maklerservice@grundvers.de"
                          }, "maklerservice@grundvers.de")
                        ])
                      ], -1))
                    ])
                  ])
                ]),
                _: 1,
                __: [25,26]
              }),
              _createVNode(_component_info_box, { id: "beratungsAngebotDirekt" }, {
                default: _withCtx(() => [
                  _cache[29] || (_cache[29] = _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "Sie wohnen in einem anderen Haus?")
                  ], -1)),
                  _cache[30] || (_cache[30] = _createElementVNode("p", { class: "u-copy-s" }, " Unser Beratungsteam erstellt Ihnen gern ein individuelles Angebot. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr. ", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_icon_sprite, {
                          "css-klassen": "u-color-primary",
                          "icon-name": "icon-phone"
                        })
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "o-media-object__content" }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            class: "inherited",
                            href: "tel:+49-40-3766-3366"
                          }, "Tel.: 040 3766 3366")
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_icon_sprite, {
                          "css-klassen": "u-color-primary",
                          "icon-name": "icon-paper-airplane"
                        })
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "o-media-object__content" }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            class: "inherited",
                            href: "mailto:kundenservice@grundvers.de"
                          }, "kundenservice@grundvers.de")
                        ])
                      ], -1))
                    ])
                  ])
                ]),
                _: 1,
                __: [29,30]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.piniaStore.state.isMakler)
        ? (_openBlock(), _createBlock(_component_ueberschrift, {
            key: 1,
            titel: "Versicherungssumme"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => [
              _cache[32] || (_cache[32] = _createTextVNode(" Höhe der Ver­sich­er­ungs­summe in €")),
              _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_13, [
                _cache[31] || (_cache[31] = _createTextVNode(" Empfohlen: 650 € je m² Wohnfläche ")),
                (_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "u-text-align-left gev19__contexthelp-open",
                      title: "Hilfe anzeigen",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.wechsleSichtbarkeit('versicherungssummeHinweisMakler')))
                    }))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "u-text-align-left gev19__contexthelp-open",
                      title: "Hilfe anzeigen",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.wechsleSichtbarkeit('versicherungssummeHinweisDirekt')))
                    }))
              ])
            ]),
            _: 1,
            __: [32,33]
          }),
          _createVNode(_component_zelle, { breite: 3 }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.versicherungssumme) = $event)),
                id: "versicherungssumme",
                name: "versicherungssumme",
                type: "number",
                onKeydown: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                class: "c-form-control__input",
                min: "10000",
                max: "2000000",
                required: "",
                "aria-required": "true",
                "aria-label": "Höhe der Versicherungssumme",
                placeholder: "€",
                "data-fehlermeldung": "Bitte geben Sie eine Versicherungssumme in vollen Euro (mind. 10.000 EUR) ohne Punkt und Komma ein.",
                "data-cy": "versicherungssumme"
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.tarifinformationen.versicherungssumme,
                  void 0,
                  {
                    lazy: true,
                    trim: true,
                    number: true
                  }
                ]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.versicherungssumme
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 6,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_infotext, {
                name: "versicherungssummeHinweisMakler",
                "css-klassen": "o-grid__cell--no-space",
                text: "Ab einer Versicherungssumme von 650 € je m<sup>2</sup> Wohnfläche erklären wir den Unterversicherungsverzicht."
              }),
              _createVNode(_component_infotext, {
                name: "versicherungssummeHinweisDirekt",
                "css-klassen": "o-grid__cell--no-space",
                text: "Die Versicherungssumme soll dem Versicherungswert des gesamten Hausrats\n        entsprechen, also dem Betrag, der für die Neuanschaffung des gesamten\n        Hausrats aufgewendet werden müsste. Ist die Versicherungssumme zu\n        niedrig angesetzt, liegt eine Unterversicherung vor und der Schaden wird\n        nur anteilsmäßig ersetzt. Einen Abzug wegen Unterversicherung können Sie\n        vermeiden, wenn Sie pro qm Wohnfläche eine Versicherungssumme von\n        650 Euro vereinbaren."
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ueberschrift, { titel: "Geburtsdatum" }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => [
              _cache[34] || (_cache[34] = _createTextVNode("Geburtsdatum ")),
              (_ctx.piniaStore.state.isMakler)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "u-text-align-left gev19__contexthelp-open",
                    title: "Hilfe anzeigen",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.wechsleSichtbarkeit('geburtsdatumHinweisMakler')))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1,
            __: [34]
          }),
          _createVNode(_component_zelle, { breite: 6 }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                style: {"width":"50%"},
                type: "date",
                id: "geburtsdatum",
                name: "geburtsdatum",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum) = $event)),
                class: "c-form-control__input",
                placeholder: "TT.MM.JJJJ",
                title: "Geburtsdatum im Format TT.MM.JJJJ",
                required: "",
                "aria-required": "true",
                "aria-label": "Geburtsdatum im Format TT.MM.JJJJ",
                "data-checkalter18bis100": "true",
                "data-cy": "versicherungsnehmerGeburtstag"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum,
                  void 0,
                  {
                    lazy: true,
                    trim: true
                  }
                ]
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.geburtsdatum
              }, null, 8, ["fehler-text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 6,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_infotext, {
                name: "geburtsdatumHinweisMakler",
                "css-klassen": "o-grid__cell--no-space",
                text: "Versicherungsnehmer ab 60 Jahren erhalten in diesem Tarifrechner automatisch einen günstigeren Beitrag."
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 3,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                "data-cy": "submitZumVergleich"
              }, " Weiter zum Vergleich ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.istSichtbar('modal-AnpassungVersicherungssumme'))
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 2,
            text: "Mit der gewählten Versicherungssumme liegt eine Unterversicherung vor und ein Schaden wird nur\n      anteilsmäßig ersetzt. Einen Abzug wegen Unterversicherung können Sie vermeiden, wenn Sie pro qm Wohnfläche\n      eine Versicherungssumme von 650 Euro vereinbaren.",
            titel: "Anpassung Versicherungssumme",
            onCloseModal: _cache[19] || (_cache[19] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-AnpassungVersicherungssumme')))
          }, {
            inhalt: _withCtx(() => [
              _createVNode(_component_zeile, null, {
                default: _withCtx(() => [
                  _createVNode(_component_zelle, { "class-override": "o-grid__cell o-grid__cell--12 o-grid__cell--6-360 u-form-grid-nospace-y" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "c-button",
                        type: "button",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.empfohleneVersicherungssummeVerwenden()))
                      }, " Weiter mit " + _toDisplayString(_ctx.formatCurrency(_ctx.empfohleneVersicherungssumme)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_zelle, { "class-override": "o-grid__cell o-grid__cell--12 o-grid__cell--6-360 u-form-grid-nospace-y" }, {
                    default: _withCtx(() => [
                      (
                _ctx.formatCurrency(_ctx.empfohleneVersicherungssumme) !==
                _ctx.formatCurrency(_ctx.piniaStore.state.tarifinformationen.versicherungssumme)
              )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "c-button u-text-align-left",
                            type: "button",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.gewaehlteVersicherungssummeVerwenden()))
                          }, " Weiter mit " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.tarifinformationen.versicherungssumme)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.istSichtbar('modal-GrenzwerteUeberschritten'))
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 3,
            onCloseModal: _cache[20] || (_cache[20] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-GrenzwerteUeberschritten'))),
            "hat-schliessen-button": true,
            titel: "Online leider kein Angebot möglich"
          }, {
            inhalt: _withCtx(() => _cache[35] || (_cache[35] = [
              _createElementVNode("p", null, " Online können wir leider kein Angebot erstellen, wenn die Wohnfläche über 300 m² liegt oder die Versicherungssumme mehr als 200.000 EUR beträgt. ", -1),
              _createElementVNode("p", null, " Unser Beratungsteam steht Ihnen gerne zur Verfügung und erstellt für Sie ein individuelles Angebot. Sie können uns von Montag bis Freitag zwischen 8:00 und 18:00 Uhr unter 040 37663-366 erreichen. ", -1)
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}